import { httpApi } from '@app/api/http.api';
import { FirmData, FirmDataRow, FirmDataViewModel } from '@app/domain/FirmModel';

export interface Pagination {
  current?: number;
  pageSize?: number;
  total?: number;
}
export interface FirmTableData {
  data: FirmDataRow[];
  pagination: Pagination;
}

export const PostNewFirm = (firmData: FirmDataViewModel): Promise<FirmDataViewModel> =>
  httpApi.post<FirmDataViewModel>('/apim/v1/firm/register', { ...firmData }).then(({ data }) => data);

export const GetAllActiveFirm = (pagination: Pagination, searchString: string): Promise<FirmTableData> =>
  httpApi
    .get<FirmTableData>('/apim/v1/firm', {
      params: { pagenumber: pagination.current, rowsOfpage: pagination.pageSize, searchstring: searchString },
    })
    .then(({ data }) => data);

export const getFirmById = (id: number): Promise<FirmDataViewModel> =>
  httpApi.get<FirmDataViewModel>('/apim/v1/firm/' + id).then(({ data }) => data);

// eslint-disable-next-line
export const updateFirm = (id: number, data: any): Promise<FirmData> =>
  httpApi.put<FirmData>('/apim/v1/firm/' + id, { data }).then(({ data }) => data);
